<template>
<div>
<ContentHeader  v-if="item"  :title="item.name"  :show_button="true"  icon="arrow-left" buttontype="danger" label="Listeye Geri Dön" url="QuestionlistQuestions" :urlparams="headerurlparams"></ContentHeader>
<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>

<template v-if="!loading">
<div class="mt-4">
<ClickEditInputText  title="Bölüm" :value="item.name" valkey="name" @dataChanged="dataChanged" />
<ClickEditInputTextArea  title="Açıklama" :value="item.description" valkey="description" @dataChanged="dataChanged" />

<ClickEditNumber title="Bölüm Puanı" :value="item.points" valkey="points" @dataChanged="dataChanged"  :steps="0.01" v-if="$store.state.sections.section.questionlist.calculate_points" />

<ClickEditSwitch  title="Görünür" :value="item.show_section" valkey="show_section" @dataChanged="dataChanged" />
<ClickEditSwitch  title="Aktif" :value="item.active" valkey="active" @dataChanged="dataChanged" />
<ClickEditSwitch  title="Alt Bölümleri Sayfa Olarak Göster" :value="item.show_subsections_as_page" valkey="show_subsections_as_page" @dataChanged="dataChanged" />


</div>
</template>


</div>
</template>

<script>
export default {

  name: 'SectionGeneral',

  data () {
    return {
    	item:null,
    	loading:true,
    }
  },
  mounted()
  {
  	this.$store.dispatch('ui/setActiveTab',"bolum") 
  	this.getData()
  },
  computed:{
    headerurlparams()
    {
      return {id:this.item.questionlist_id}
    }
  },
  methods:{
  	async getData()
    {
        this.item = await this.generalApiGetWithoutLoader("questionlists/section/"+this.$route.params.id)
        console.log(this.item)        
        await this.$store.dispatch('sections/setSection',this.item)
        this.loading = await false
    },
    dataChanged(data)
    {
      console.log(data.value)
      console.log(data.key)
      //return false
      let formdata = new FormData()
      formdata.append(data.key,data.value)      
      this.generalSubmission(formdata,"questionlists/section/update/"+this.item.id,this.afterdataChanged)
    },
    afterdataChanged(response)
    {
      console.log("data changed");
      console.log(response);
      
      this.item = response.data
      this.$store.dispatch('sections/setSection',this.item)


      if(response.data.status && response.data.status !==200)
      {
        
      }
      else
      {
        console.log("200");
        
      }
      
    },
  },
}
</script>

<style lang="css" scoped>
</style>